export * from './news.component'
export * from './detail'